export default __webpack_public_path__ + "static/media/calVec.14e9f825.svg";